import { configQuery } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

var _a;
var COUNTRY_TO_JURISDICTION = (_a = {},
    _a[Country.UNITED_KINGDOM] = Jurisdiction.UKGC,
    _a[Country.SWEDEN] = Jurisdiction.SGA,
    _a[Country.LATVIA] = Jurisdiction.IAUI,
    _a[Country.ARGENTINA] = Jurisdiction.LOTBA,
    _a[Country.ROMANIA] = Jurisdiction.ONJN,
    _a[Country.CANADA] = Jurisdiction.AGCO,
    _a[Country.ESTONIA] = Jurisdiction.EMTA,
    _a[Country.PHILIPPINES] = Jurisdiction.PAGCOR,
    _a[Country.SPAIN] = Jurisdiction.DGOJ,
    _a);
var JurisdictionCommonService = /** @class */ (function () {
    function JurisdictionCommonService(countryToJurisdiction, defaultJurisdiction) {
        this.countryToJurisdiction =
            countryToJurisdiction !== null && countryToJurisdiction !== void 0 ? countryToJurisdiction : COUNTRY_TO_JURISDICTION;
        this.defaultJurisdiction = defaultJurisdiction !== null && defaultJurisdiction !== void 0 ? defaultJurisdiction : Jurisdiction.MGA;
    }
    JurisdictionCommonService.prototype.getJurisdictionByCountry = function (country) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!country) {
                            return [2 /*return*/, this.defaultJurisdiction];
                        }
                        return [4 /*yield*/, this.getCountryMap()];
                    case 1:
                        config = _b.sent();
                        return [2 /*return*/, (_a = config[country]) !== null && _a !== void 0 ? _a : this.defaultJurisdiction];
                }
            });
        });
    };
    JurisdictionCommonService.prototype.getCountryMap = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('jurisdiction')];
                    case 1:
                        config = _a.sent();
                        return [2 /*return*/, config !== null && config !== void 0 ? config : this.countryToJurisdiction];
                }
            });
        });
    };
    return JurisdictionCommonService;
}());

export { COUNTRY_TO_JURISDICTION, JurisdictionCommonService };
